export default
    {
        // url: this.$store.state.http.quirofano.YYYY,
        listProductividad: "/quirofano/listProductividad",
        listProductividadYear: "/quirofano/listProductividadYear",

        listCirugias: "/quirofano/listCirugias",
        listCirugiasMini: "/quirofano/listCirugiasMini",

        enviaCirugiaEmail: "/quirofano/enviaCirugiaEmail",

        crea: "/quirofano/createCirugia",
        detalle: "/quirofano/detalleCirugia",
        egresa: "/quirofano/egresaCirugia",
        listTv: "/quirofano/listCirugiasTv",
        procesa: "/quirofano/procesaCirugia",
        reagenda: "/quirofano/reagendaCirugia",

        guardaCirugiaSegura:"/quirofano/guardaCirugiaSegura",
        guardaArchivoCirugiaSegura:"/quirofano/guardaArchivoCirugiaSegura",
        listCirugiaSegura:"/quirofano/listCirugiaSegura",
        listArchivoCirugiaSegura:"/quirofano/listArchivoCirugiaSegura",
        cargaFondo:"/quirofano/cargaFondo"
    }
